<!-- 
  详情页 - 装配产品信息
  props:
    id: 详情id
 -->
<template>
  <div class="v-tabs product-list">
    <div class="head">
      <div class="total">
        {{tableData.length}}种产品{{totalProducts}}件
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        border
        highlight-current-row
        style="width: 100%">
        <el-table-column
          v-for="(h,index) in explains"
          :label="h.attrName"
          :prop="h.attr"
          :key="h.attr"
          show-overflow-tooltip
          min-width="100">
          <template slot-scope="scope">
            <template v-if="h.attr==='warehouse'">
              <span>{{scope.row.result[index].attrValue.value}}</span>
            </template>
            <template v-else-if="[5,6,8,10].indexOf(h.fieldType) === -1">
              <span>{{scope.row.result[index].attrValue || '--'}}</span>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      explains: [],
      tableData: []
    }
  },
  computed: {
    // totalProducts () {
    //   let i = 0
    //   this.tableData.forEach(item => {
    //     i += item.num
    //   })
    //   return Number(i.toFixed(5))
    // }
    totalProducts () {
      let i = 0
      this.tableData.forEach(item => {
        item.result.forEach(obj => {
          if (obj.attr === 'num') {
            i = utils.plus(i, obj.attrValue)
          }
        })
      })
      return i
    }
  },
  methods: {
    getList () {
      let url = '/assemble/assembleProductList.html'
      let params = {
        id: this.id
      }
      api.post(url, params, (data) => {
        this.explains = data.explains
        this.tableData = data.outProductList
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// outproduct-list.vue?2c06c0da